import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL || ""}/api` });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bcrp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Ismeretlen hiba";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "most";
  if (diff < 3600) return `${Math.floor(diff / 60)} perce`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} órája`;
  if (diff < 86400 * 30) return `${Math.floor(diff / 86400)} napja`;
  return new Date(iso).toLocaleDateString("hu-HU");
};

export const ROLE_STYLES = {
  player: "border-white/15 text-white/60",
  moderator: "border-emerald-400/40 text-emerald-300",
  admin: "border-[rgba(94,177,255,0.6)] text-[var(--glow)]",
  owner: "border-amber-400/50 text-amber-300",
};
